import queryString from 'query-string'

const GET_TASKS_OVERVIEW = 'dofe-bo/activityTasks/GET_TASKS_OVERVIEW'
const GET_TASKS_OVERVIEW_SUCCESS =
  'dofe-bo/activityTasks/GET_TASKS_OVERVIEW_SUCCESS'
const GET_TASKS_OVERVIEW_FAIL = 'dofe-bo/activityTasks/GET_TASKS_OVERVIEW_FAIL'
const SET_SORT = 'dofe-bo/activityTasks/SET_SORT'
const SET_FILTER = 'dofe-bo/activityTasks/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/activityTasks/SET_BASE_FILTER'
const SET_LIMIT = 'dofe-bo/activityTasks/SET_LIMIT'
const SET_OFFSET = 'dofe-bo/activityTasks/SET_OFFSET'
const SET_DISABLED_CACHE = 'dofe-bo/activityTasks/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/activityTasks/REMOVE_DETAIL_DATA'

const initialState = {
  list: [],
  byId: {},
  overviewMyOnly: {
    list: []
  },
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 4,
  filter: '',
  loading: false,
  loaded: false
}

const handleCreateArray = oldArr =>
  oldArr.map((item, index) => ({
    label: item.name,
    value: item.count,
    nameId: item.nameId,
    id: index + 1
  }))

export default function reducer (state = initialState, action = {}) {
  let byId = state.byId
  let list = state.list
  let overviewMyOnly = state.overviewMyOnly
  let result = null
  let orgTasks = null

  switch (action.type) {
    case GET_TASKS_OVERVIEW:
      return {
        ...state,
        loading: true,
        overviewMyOnly: {
          ...overviewMyOnly,
          loading: true
        }
      }
    case GET_TASKS_OVERVIEW_SUCCESS:
      // when calling with leader, returning JSON is more complex
      result = JSON.parse(action.result)
      orgTasks = action.awardLeaderId
        ? result.organizationTasks
        : result

      if (action.orgId) {
        byId = {
          ...state.byId,
          [action.orgId]: handleCreateArray(orgTasks)
        }
      } else {
        list = handleCreateArray(orgTasks)
      }

      if (!action.orgId && action.activeOrganizationId) {
        byId = {
          ...state.byId,
          [action.activeOrganizationId]: handleCreateArray(orgTasks)
        }
      }

      if (action.awardLeaderId) {
        overviewMyOnly = {
          ...overviewMyOnly,
          list: handleCreateArray(result.awardLeaderTasks),
          loading: false,
          loaded: true
        }
      }

      return {
        ...state,
        list,
        loading: false,
        loaded: true,
        byId,
        overviewMyOnly
      }
    case GET_TASKS_OVERVIEW_FAIL:
      return {
        ...state,
        list: [],
        loading: false,
        loaded: false,
        error: action.error,
        overviewMyOnly: {
          ...(state.overviewMyOnly),
          list: [],
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case SET_SORT:
      return Object.assign({}, state, {
        sort: action.sortBy
      })
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy
      })
    case SET_LIMIT:
      return Object.assign({}, state, {
        limit: action.limit
      })
    case SET_OFFSET:
      return Object.assign({}, state, {
        offset: action.offset
      })
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    default:
      return state
  }
}

export function getTasksOverview (tasks, { orgId, activeOrganizationId, awardLeaderId } = {}, baseFilter = '') {
  const qp = {}

  if (orgId) {
    qp.filterForOrganizationId = orgId
  }

  if (awardLeaderId) {
    qp.awardLeaderId = awardLeaderId
  }


  return {
    types: [
      GET_TASKS_OVERVIEW,
      GET_TASKS_OVERVIEW_SUCCESS,
      GET_TASKS_OVERVIEW_FAIL
    ],
    promise: client =>
      client.get(`api/tasks/overview?${queryString.stringify(qp)}&filter=${baseFilter}`,
        {
          textResponse: true
        }),
    orgId,
    activeOrganizationId,
    awardLeaderId
  }
}

export function setSort (sortBy) {
  return {
    type: SET_SORT,
    sortBy
  }
}

export function setFilter (filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setBaseFilter (filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setLimit (limit) {
  return {
    type: SET_LIMIT,
    limit
  }
}

export function setOffset (offset) {
  return {
    type: SET_OFFSET,
    offset
  }
}

export function removeDetailData () {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache () {
  return {
    type: SET_DISABLED_CACHE
  }
}
